import { render, staticRenderFns } from "./page-2.vue?vue&type=template&id=9b143282"
import script from "./page-2.vue?vue&type=script&lang=js"
export * from "./page-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_css-loader@6.11.0_webpack@5.107.2_postcss@8_cd0c78093fd3e0fe2601f4284460232b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports